import AutoModeIcon from "@mui/icons-material/AutoMode";
import { IcoX, IcoSend } from "./icons";

const AutoCount = ({ count }) =>
  count > 0 ? (
    <span
      title="Auto Selected Results"
      style={{
        color: "#16a34a",
        fontWeight: 700,
        display: "inline-flex",
        alignItems: "center",
        gap: 2,
        marginLeft: 4,
      }}
    >
      (<AutoModeIcon sx={{ fontSize: "14px" }} /> {count})
    </span>
  ) : null;

// ─── Submit Review Modal ───────────────────────────────────────────────────

export default function SubmitReviewModal({
  onClose,
  onConfirm,
  reviewEphRecords,
  reviewVendorRecords,
  reviewNotFoundRecords = [],
  checkedRecords,
  ephAutoSelected = 0,
  vendorAutoSelected = 0,
  showReviewed = true,
  isSubmittingReview,
  submitReviewError,
}) {
  const ephSel = reviewEphRecords.filter((r) => checkedRecords.has(r.id))
    .length;
  const vndSel = reviewVendorRecords.filter((r) => checkedRecords.has(r.id))
    .length;
  const nfSel = reviewNotFoundRecords.filter((r) => checkedRecords.has(r.id))
    .length;
  const total =
    reviewEphRecords.length +
    reviewVendorRecords.length +
    reviewNotFoundRecords.length;
  const notActioned = total - ephSel - vndSel - nfSel;

  return (
    <div className="rc-mover" onClick={onClose}>
      <div className="rc-mdl sm" onClick={(e) => e.stopPropagation()}>
        <div className="rc-mdl-hdr neut">
          <div className="rc-mdl-hl">
            <div className="rc-mdl-ico">
              <IcoSend size={15} cls="ic-f" />
            </div>
            <p className="rc-mdl-htit">Submit Review</p>
          </div>
          <button className="rc-mdl-close" onClick={onClose}>
            <IcoX size={15} />
          </button>
        </div>
        <div className="rc-mdl-body plain">
          <p className="rc-mdl-desc">
            Review submission summary before confirming.
          </p>
          <div className="rc-sub-rows">
            <div className="rc-sub-row">
              <div className="rc-sub-l">
                <span className="rc-sub-dot blue" />
                <span className="rc-sub-lbl">EPH Records</span>
              </div>
              <div>
                <span className="rc-sub-cnt">{ephSel}</span>
                <span className="rc-sub-tot">
                  {" "}
                  / {reviewEphRecords.length} selected{" "}
                  <span style={{ color: "#16a34a" }}>
                    {showReviewed && `(Reviewed - ${ephSel - ephAutoSelected})`}
                  </span>
                </span>
                <AutoCount count={ephAutoSelected} />
              </div>
            </div>
            <div className="rc-sub-row">
              <div className="rc-sub-l">
                <span className="rc-sub-dot purple" />
                <span className="rc-sub-lbl">Vendor Records</span>
              </div>
              <div>
                <span className="rc-sub-cnt">{vndSel}</span>
                <span className="rc-sub-tot">
                  {" "}
                  / {reviewVendorRecords.length} selected{" "}
                  <span style={{ color: "#16a34a" }}>
                    {showReviewed &&
                      `(Reviewed - ${vndSel - vendorAutoSelected})`}
                  </span>
                </span>
                <AutoCount count={vendorAutoSelected} />
              </div>
            </div>
            {reviewNotFoundRecords.length > 0 && (
              <div className="rc-sub-row">
                <div className="rc-sub-l">
                  <span className="rc-sub-dot amber" />
                  <span className="rc-sub-lbl">Not Found Records</span>
                </div>
                <div>
                  <span className="rc-sub-cnt">{nfSel}</span>
                  <span className="rc-sub-tot">
                    {" "}
                    / {reviewNotFoundRecords.length} selected{" "}
                    <span style={{ color: "#16a34a" }}>
                      {showReviewed && `(Reviewed - ${nfSel})`}
                    </span>
                  </span>
                </div>
              </div>
            )}
            <div className="rc-sub-row warn">
              <div className="rc-sub-l">
                <span className="rc-sub-dot amber" />
                <span className="rc-sub-lbl">Not Actioned</span>
              </div>
              <div>
                <span className="rc-sub-cnt">{notActioned}</span>
                <span className="rc-sub-tot"> / {total} not selected</span>
              </div>
            </div>
          </div>
          {submitReviewError && (
            <p style={{ color: "#dc2626", fontSize: 12, marginTop: 8 }}>
              {submitReviewError}
            </p>
          )}
        </div>
        <div className="rc-mdl-foot">
          <button
            className="btn btn-o"
            style={{ flex: 1 }}
            onClick={onClose}
            disabled={isSubmittingReview}
          >
            Cancel
          </button>
          <button
            className="btn btn-r"
            style={{ flex: 1 }}
            onClick={onConfirm}
            disabled={isSubmittingReview}
          >
            {isSubmittingReview ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
}
